<div class="form-group">
  <label *ngIf="label" class="label--primary">
    <span class="form-label">
      {{ label !== ' ' ? label : '&nbsp;' }}
      <span *ngIf="secondaryLabel"> - </span>
      <small class="label-secondary">{{ secondaryLabel }}</small>
    </span>
  </label>
  <div
    [ngClass]="{ 'dropdown dropdown--native': true, 'dropdown-disabled': disabled || readonly }"
    (clickOutside)="handleClickOutsideDefaultDropdown()"
    (click)="onMouseclick($event)"
  >
    <!-- Start Group Dropdown -->
    <div class="dropdown-simple dropdown-select">
      <select
        [attr.id]="selectId"
        [required]="required"
        [attr.name]="name"
        [attr.aria-label]="selectedOptionLabel"
        aria-hidden="true"
      >
        <option *ngIf="placeholder">{{ placeholder }}</option>
        <ng-container *ngIf="group">
          <optgroup *ngFor="let option of options" [attr.label]="option.label">
            <option *ngFor="let option of option.items" [value]="option.value" [selected]="selectedOption === option">
              {{ option.label }}
            </option>
          </optgroup>
        </ng-container>
        <ng-container *ngIf="!group">
          <option *ngFor="let option of options" [value]="option.value" [selected]="selectedOption === option">
            {{ option.label }}
          </option>
        </ng-container>
      </select>
    </div>
    <!-- End Group and header Group Dropdown-->

    <!--  Input form control -->
    @if (multiSelect) {
      <label [ngClass]="{ 'form-control': true, 'is-active': isDropdownOpen }">
        {{ multipleSelectedOptionsLabel() }}
      </label>
    } @else if (filter) {
      <rx-dropdown-search
        [ariaLabel]="selectedOptionLabel"
        [disabled]="disabled"
        [readonly]="readonly"
        [placeholder]="placeholder"
        [filterValue]="filterValue"
        [isDropdownOpen]="isDropdownOpen"
        (onInputFocus)="onInputFocus($event)"
        (onInputBlur)="onInputBlur($event)"
        (onFilter)="onFilter($event)"
      />
    } @else {
      <label [ngClass]="{ 'form-control': true, 'is-active': isDropdownOpen }">
        {{ selectedOptionLabel || placeholder || '-' }}
      </label>
    }

    <!--Start Dropdown menu-->
    <div
      [style.transform]="dropdownPosition"
      class="dropdown-menu pb-0"
      [ngClass]="{ 'dropdown-menu--no-bottom-radius': showFooter }"
      *ngIf="isDropdownOpen"
      @collapseExpand
      [ngClass]="{ show: isDropdownOpen }"
    >
      <div *ngIf="multiSelect && filter" class="px-3">
        <label>{{ searchText }}</label>
        <rx-dropdown-search
          [ariaLabel]="selectedOptionLabel"
          [filterValue]="filterValue"
          [isDropdownOpen]="isDropdownOpen"
          (onFilter)="onFilter($event)"
        />
        <hr class="my-1" />
      </div>
      <!-- Dropdown options with virtual scroll -->
      <cdk-virtual-scroll-viewport
        [itemSize]="itemHeight"
        [minBufferPx]="virtualScrollBufferSize.min"
        [maxBufferPx]="virtualScrollBufferSize.max"
        class="dropdown-menu-items"
        [style.height]="virtualScrollHeight"
      >
        <div *ngIf="filter" class="dropdown__input-search" (click)="$event.stopPropagation()">
          <span class=""></span>
        </div>
        <ul class="dropdown-items dropdown-item-onetime" role="listbox">
          <!-- Grouped options -->
          <ng-container *ngIf="group">
            <ng-template ngFor let-optgroup [ngForOf]="optionsToDisplay">
              <li class="dropdown-item-group dropdown-header">
                <span>{{ optgroup.label || emptyOptionLabel }}</span>
              </li>
              <ng-container
                *ngTemplateOutlet="itemslist; context: { $implicit: optgroup.items, selectedOption: selectedOption }"
              ></ng-container>
            </ng-template>
          </ng-container>

          <!-- Simple dropdown -->
          <ng-container *ngIf="!group">
            <ng-container
              *ngTemplateOutlet="itemslist; context: { $implicit: optionsToDisplay, selectedOption: selectedOption }"
            ></ng-container>
          </ng-container>
          <ng-template #itemslist let-options let-selectedOption="selectedOption">
            @if (multiSelect) {
              <rx-checkbox
                *cdkVirtualFor="let option of options; trackBy: trackByOptions; let index = index"
                role="option"
                class="dropdown-item pb-1 pl-3"
                [label]="option.label"
                [secondaryLabel]="option.secondaryLabel"
                [value]="option.value"
                [attr.aria-label]="option.label"
                [ngModel]="isMultiSelectItemSelected(option)"
                [id]="option?.testId || index"
                [attr.data-qa]="
                  'test-checkbox-' + (option?.testId || index) + (isMultiSelectItemSelected(option) ? '-checked' : '')
                "
                (change)="onMultiSelectItem(option)"
              />
            } @else {
              <li
                *cdkVirtualFor="let option of options; trackBy: trackByOptions"
                role="option"
                (click)="onItemClick($event, option)"
                [attr.aria-label]="option.label"
                [ngClass]="{
                  'dropdown-item': true,
                  active: selectedOption === option,
                  'dropdown-item-disabled': option.disabled,
                  'dropdown-item-empty': !option.label || option.label.length === 0,
                }"
                [attr.data-qa]="option?.testId"
              >
                <span>{{ option.label || emptyOptionLabel }}</span>
                <span *ngIf="displayLabelValue"> ({{ option.value }})</span>
              </li>
            }
          </ng-template>

          <li *ngIf="filter && optionsToDisplay && optionsToDisplay.length === 0" class="dropdown-empty-message">
            {{ filterNoResultMessage }}
          </li>
        </ul>
      </cdk-virtual-scroll-viewport>
    </div>

    <div *ngIf="showFooter && isDropdownOpen" @collapseExpand class="dropdown-footer" [style]="footerPosition">
      <ng-content></ng-content>
    </div>
    <!--End Dropdown menu-->
  </div>
  <div class="lpo">
    <ng-content select="[rx-error]"></ng-content>
    <div rx-error *ngIf="error" class="rx-error">{{ error }}</div>
  </div>
</div>
